import axios from 'axios';
import { ProfileObjectOnServer } from '../../types/Profile';

export default function updateHrUser(data: ProfileObjectOnServer) {
  const url = `${process.env.REACT_APP_API_URL}/api/create-profile`;
  return axios.post(url, { data });
}
